var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{attrs:{"id":"street-view-modal","title":"Street View","hide-footer":"","centered":"","size":"lg","lazy":"","static":""}},[_c('StreetView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }